export default "__VITE_ASSET__D_L$cw8b__"